export const NOT_FOUND_PAGE_DATA_TEST_ID = 'not-found-page'
